import {match, Redirect, Switch} from "react-router";
import * as React from "react";
import {UserPermission} from "../model/user/UserPermission";
import RestrictedRoute from "./route/RestrictedRoute";
import OrganisationUserList from "../components/admin/users/OrganisationUserList";
import OrganisationUserCreate from "../components/admin/users/OrganisationUserCreate";
import OrganisationUserUpdate from "../components/admin/users/OrganisationUserUpdate";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Users router view
 */
export default class OrganisationUsersRouter extends React.PureComponent<RouteProps> {
	allowedPermissions = [UserPermission.AdminAll, UserPermission.AdminUsers];

	render() {
		return (
			<Switch>
				<RestrictedRoute exact
								 path={this.props.match.url}
								 component={OrganisationUserList}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/create"}
								 component={OrganisationUserCreate}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:userId"}
								 component={OrganisationUserUpdate}
								 allowedPermissions={this.allowedPermissions}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		);
	}
}